import { render, staticRenderFns } from "./TicketRowActions.vue?vue&type=template&id=0b9c012c&"
import script from "./TicketRowActions.vue?vue&type=script&lang=js&"
export * from "./TicketRowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports